// ---------------------------------------------------------------------------
// PWA_ControlBillet — useAuthRefresh hook
// Periodically refreshes the JWT access token while the user is logged in.
// ---------------------------------------------------------------------------

import { useEffect } from 'react';
import { useAuthStore } from '@/store/auth-store';
import { authService } from '@/services/auth-service';

/** 13 minutes — access token expires at 15 min, refresh before expiry. */
const REFRESH_INTERVAL = 13 * 60 * 1000;

export function useAuthRefresh(): void {
  const isAuthenticated = useAuthStore((s) => s._isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;

    const timer = setInterval(() => {
      authService.refresh().catch(() => {
        console.warn('[AuthRefresh] Token refresh failed');
      });
    }, REFRESH_INTERVAL);

    return () => clearInterval(timer);
  }, [isAuthenticated]);
}
